export default __webpack_public_path__ + "static/media/3536 spice rack C top.b3b65426.png";